import { Injectable, OnInit } from '@angular/core';

import { environment } from '../../environments/environment';

import { Router } from '@angular/router';

import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ThemeService implements OnInit {
  currentTheme!: string;

  constructor(private router: Router, private http: HttpClient) { 
    
  }

  // setTheme(): void {
  //   const baseUrl = environment.apiUrl; 
  //   if (baseUrl.includes('hospital')) {
  //     this.currentTheme = 'hospital';
  //     document.body.classList.add('hospital-theme');
  //     document.body.classList.remove('branch-theme');
  //     this.router.navigate(['/dashboard']); 
  //   } else { 
  //     this.currentTheme = 'branch';
  //     document.body.classList.add('branch-theme');
  //     document.body.classList.remove('hospital-theme');
  //     this.router.navigate(['/home']);
  //   }
  // }

  setTheme(): void {
    if (environment.isHospitalApp) {
      this.applyHospitalTheme();
    } else {
      this.applyBranchTheme();
    }
  }

  applyBranchTheme() {
    this.currentTheme = 'branch';
    document.body.classList.add('branch-theme');
    document.body.classList.remove('hospital-theme');
  }

  applyHospitalTheme(): void {
    this.currentTheme = 'hospital';
    document.body.classList.add('hospital-theme');
    document.body.classList.remove('branch-theme');
  }

  getTheme(): string {
    return this.currentTheme;
  }

  ngOnInit(): void {
    this.setTheme();
  }
}
